var $ = require("jquery");
window.jQuery = $;
require("@fancyapps/fancybox");

$('a.fancybox').fancybox();
$('a.popup, a.fancypopup').fancybox({
    type: 'ajax'
});
